import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
import { groupEvalsBySourceRefId } from "./group-evals.js";
//#region src/modules/ServicePeriods/hooks/useActivityEvals.ts
function useActivityEvals(input) {
	const locationIds = input.locationIds?.length ? input.locationIds : input.locationId ? [input.locationId] : void 0;
	const { call, data, error, isCalling, success } = useRPC(RPCs.ServicePeriods.FindActivityEvals.v1, {
		...locationIds ? { locationIds } : {},
		pagination: {
			limit: 5e3,
			skip: 0
		},
		...input.regionIds?.length ? { regionIds: input.regionIds } : {},
		sourceRefIds: input.sourceRefIds
	}, { fire: input.sourceRefIds.length > 0 });
	return {
		bySourceRefId: groupEvalsBySourceRefId((data?.activityEvals ?? []).filter((item) => typeof item.sourceRefId === "string")),
		call,
		error,
		isCalling,
		success
	};
}
//#endregion
export { useActivityEvals };

//# sourceMappingURL=useActivityEvals.js.map